import { z } from 'zod';
import { PaginationQuery } from '../../utils/listQuery';
import { listResponse } from '../../utils/listResponse';
import { integrationCredentialSchema } from '../models/integrationCredential.schema';
import { integrationCredentialsListQuerySchema } from './list.schema';

export type IntegrationCredentialsListQuery = PaginationQuery;

export const list = (query: IntegrationCredentialsListQuery = {}) => {
  return {
    endpoint: `/integration_credentials`,
    method: 'GET',
    responseSchema: listResponse(integrationCredentialSchema),
    query: { ...query, includeTotal: true },
    querySchema: integrationCredentialsListQuerySchema.and(
      z.object({ includeTotal: z.boolean().optional() })
    ),
  } as const;
};
